export default __webpack_public_path__ + "static/images/apple.a709844c.png";